export default __webpack_public_path__ + "static/media/unselected12.3dfe38cd.png";